import { ModalFullscreen } from '@cian/ui-kit';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useFullscreenGalleryInfo, useFullscreenGalleryPagination, useFullscreenGalleryPostMessage } from './hooks';
import { trackFullscreenGalleryShow, trackPhotoSave } from './tracking';
import { closeContentFullscreen, setContentFullscreen } from '../../actions/contentFullscreen';
import { FullscreenGalleryContent } from '../../components/FullscreenGalleryContent';
import { FullscreenGalleryFooter } from '../../components/FullscreenGalleryFooter';
import { FullscreenGalleryHeader } from '../../components/FullscreenGalleryHeader';
import { FullscreenGalleryLayout } from '../../components/FullscreenGalleryLayout/FullscreenGalleryLayout';
import { gallerySelector, selectIsContentFullscreenOpen } from '../../selectors';

export const FullscreenGallery: React.FC = () => {
  const [isOpen, setOpenModal] = React.useState(false);
  const [currentSlide, setCurrentSlide] = React.useState(0);

  const isContentFullscreenOpen = useSelector(selectIsContentFullscreenOpen);
  const { slides, slideIndex } = useSelector(gallerySelector);
  const { onGalleryClose, onGalleryOpen } = useFullscreenGalleryPostMessage();

  const dispatch = useDispatch();

  const { userName, created, src, offerStr } = useFullscreenGalleryInfo();

  useFullscreenGalleryPagination(slideIndex, setCurrentSlide);

  React.useEffect(() => {
    if (isContentFullscreenOpen) {
      setOpenModal(true);
      trackFullscreenGalleryShow();

      onGalleryOpen();
    }
  }, [isContentFullscreenOpen, onGalleryOpen]);

  const handleClose = () => {
    dispatch(closeContentFullscreen());
    setOpenModal(false);
    onGalleryClose();
  };

  const handleSave = () => {
    trackPhotoSave();
  };

  const handleChange = (index: number, item: React.ReactElement) => {
    setCurrentSlide(index);
    dispatch(setContentFullscreen({ selectedImageUid: (item.props as any)['data-uid'] }));
  };

  return (
    <ModalFullscreen onClose={handleClose} open={isOpen} theme="black">
      <FullscreenGalleryLayout
        header={
          <FullscreenGalleryHeader src={src} created={created} handleClose={handleClose} handleSave={handleSave} />
        }
        content={<FullscreenGalleryContent slides={slides} currentSlide={currentSlide} onChange={handleChange} />}
        footer={<FullscreenGalleryFooter userName={userName} offerStr={offerStr} />}
      />
    </ModalFullscreen>
  );
};
